import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
  } from 'redux-saga/effects';
  import { ApprovalManagementActions as actions, notificationActions } from '../actions';
  import { ApprovalManagementService } from '../services';
  
  /* Add Hierarchy Sagas */
  function* handleAddHierarchyRequest() {
    const action = yield take(actions.addHierarchyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(ApprovalManagementService.createHierarchy, dataParams);
      if (res.isError) {
        yield put(actions.addHierarchyError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.addHierarchySuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.addHierarchyError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
  
  /* Get All Hierarchy Sagas*/
  function* handleGetAllHierarchyRequest() {
    const action = yield take(actions.getAllHierarchyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(ApprovalManagementService.getAllHierarchy, dataParams);
  
      if (res.isError) {
        yield put(actions.getAllHierarchyError(res));
  
      } else {
        yield put(actions.getAllHierarchySuccess(res));
      }
  
    } catch (error) {
      yield put(actions.getAllHierarchyError());
    }
  }
  
  /* Update Department Sagas */
  function* handleUpdateHierarchyRequest() {
    const action = yield take(actions.updateHierarchyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(ApprovalManagementService.updateHierarchy, dataParams);
      if (res.isError) {
        yield put(actions.updateHierarchyError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.updateHierarchySuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.updateHierarchyError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }

  /* Delete Department Sagas*/
  function* handleDeleteHierarchyRequest() {
    const action = yield take(actions.deleteHierarchyRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(ApprovalManagementService.deleteHierarchy, dataParams);
      if (res.isError) {
        yield put(actions.deleteHierarchyError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
      } else {
        yield put(actions.deleteHierarchySuccess(res));
        yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
      }
    } catch (error) {
      yield put(actions.deleteHierarchyError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
  }
  
  
  /* -----------Watchers------------- */
  function* handleAddHierarchyWatcher() {
    yield takeEvery(
      actions.addHierarchyRequest,
      handleAddHierarchyRequest,
    );
  }
  
  function* handleGetHierarchyWatcher() {
    yield takeEvery(
      actions.getAllHierarchyRequest,
      handleGetAllHierarchyRequest,
    );
  }
  
  
  function* handleUpdateHierarchyWatcher() {
    yield takeEvery(
      actions.updateHierarchyRequest,
      handleUpdateHierarchyRequest,
    );
  }
  
  function* handleDeleteHierarchyWatcher() {
    yield takeEvery(
      actions.deleteHierarchyRequest,
      handleDeleteHierarchyRequest
    );
  }
  
  
  
  function* rootDepartmentSaga() {
    yield all([
      handleAddHierarchyRequest(),
      handleAddHierarchyWatcher(),
  
      handleGetAllHierarchyRequest(),
      handleGetHierarchyWatcher(),
  
      handleUpdateHierarchyRequest(),
      handleUpdateHierarchyWatcher(),
  
      handleDeleteHierarchyRequest(),
      handleDeleteHierarchyWatcher(),
    ]);
  }
  
  export default rootDepartmentSaga;
  